import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useDropdownStore = defineStore('dropdown', () => {
  const noGoodReasons = ref(null)
  const statuses =      ref(null)
  const webSources =    ref(null)
  const woReasons =     ref([])

  function reset() {
    noGoodReasons.value   = null
    statuses.value        = null
    webSources.value      = []
    woReasons.value       = []
  }

  return {
    noGoodReasons,
    statuses,
    webSources,
    woReasons,

    reset,
  }
},
{
  persist: true,
})
